import React from 'react';
import {Button} from 'epic-ue-ui';
import {withLocalization} from '@epic-core/localization';
import styled from 'styled-components';
import {handleReset} from '../jobForm.utils';

const Styled = styled.div``;

export interface FormSubmitResetButtonsProps {
    getMessage: (key: string) => string;
    formRenderProps: {
        handleSubmit;
        hasValidationErrors;
        submitFailed;
        form;
        submitSucceeded;
        values;
    };
    submitButtonlabel?: string;
    resetButtonlabel?: string;
    isInputsDisabled?: boolean;
    setSubmitErrorMsg: (e) => void;
}

const FormSubmitResetButtonsComponent = ({
    getMessage,
    formRenderProps,
    submitButtonlabel = getMessage('epic.jobs.form.submit'),
    resetButtonlabel = getMessage('epic.jobs.form.reset'),
    isInputsDisabled,
    setSubmitErrorMsg
}: FormSubmitResetButtonsProps): JSX.Element => {
    return (
        <Styled className="applicationFormButtons">
            {
                <div className="applicationFormButtons">
                    <div
                        role="button"
                        tabIndex={0}
                        style={{display: 'contents'}}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleReset(formRenderProps?.form, setSubmitErrorMsg);
                            }
                        }}>
                        <Button
                            onClick={() => {
                                handleReset(formRenderProps?.form, setSubmitErrorMsg);
                            }}
                            role="button"
                            disabled={isInputsDisabled}
                            type="secondary">
                            {resetButtonlabel}
                        </Button>
                    </div>

                    <div
                        role="button"
                        tabIndex={0}
                        style={{display: 'contents'}}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && formRenderProps?.handleSubmit) {
                                formRenderProps.handleSubmit();
                            }
                        }}>
                        <Button
                            onClick={formRenderProps?.handleSubmit}
                            disabled={isInputsDisabled}
                            type="primary">
                            {submitButtonlabel}
                        </Button>
                    </div>
                </div>
            }
        </Styled>
    );
};

const FormSubmitResetButtons = withLocalization(FormSubmitResetButtonsComponent);
export default FormSubmitResetButtons;
